import _ from "underscore";

("use strict");

const FOVIndicator = {
  getFOVIndicatorsByEquipment: (equipment) => {
    var equipmentType = equipment.get("type");
    var id = equipment.id;
    var fovIndicatorsWithThisEquipment = _.filter(
      Portal.Current.Collections.fovIndicators,
      (fovIndicator) => {
        if (fovIndicator.get(equipmentType) && fovIndicator.get(equipmentType).id === id) {
          return fovIndicator;
        }
      },
    );
    return fovIndicatorsWithThisEquipment;
  },
};

export default FOVIndicator;
